// Temporary launch lock. Set to false to re-open public customer access.
// While true:
//  - New account registration is disabled (except allowlisted beta customers).
//  - Customer login is blocked (staff/admin + allowlisted beta customers still work).
//  - Password reset requests are disabled.
export const LAUNCH_LOCKED = true;

// Allowlisted customer emails permitted through the launch lock for private
// beta testing. Compared case-insensitively. Keep this list tiny.
export const BETA_CUSTOMER_EMAILS: readonly string[] = [
  "thomasctovar@hotmail.com",
];

export function isBetaCustomerEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const normalized = email.trim().toLowerCase();
  return BETA_CUSTOMER_EMAILS.some((e) => e.toLowerCase() === normalized);
}

export const LAUNCH_LOCK_TITLE = "Private Beta";
export const LAUNCH_LOCK_MESSAGE =
  "ClaimGuard is currently in a private beta. Public sign-ups and customer sign-ins are temporarily paused while we finish end-to-end testing. Please check back soon.";
